import { Text } from '@lmn/design-system';
import { ellipsis, loadAnimation } from '@/app/components/search/styles/mixins';
import styled, { css } from 'styled-components';

export const FlightContainer = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;

  img {
    border-radius: 4px;
    margin-right: 16px;
  }
`;

export const TransportSlimTitle = styled.div`
  font-weight: ${({ theme }) => theme.kallisto.font.weight.bold};
  font-size: ${({ theme }) => theme.kallisto.font.size['150']};
  color: ${({ theme }) => theme.kallisto.color.common.black[200]};
  line-height: 16px;
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  text-transform: uppercase;
`;
export const TransportInfo = styled.div`
  min-width: 0;
  margin-right: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TransportInfoTime = styled(Text).attrs({ variant: 'Title3' })<{ isWaiting: boolean }>`
  display: flex;
  align-items: center;

  b {
    color: ${({ theme }) => theme.kallisto.color.common.semantic.warning[600]};
    margin-left: 2px;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0.01em;
  }

  ${({ isWaiting }) =>
    isWaiting &&
    css`
      width: 104px;
      border-radius: 4px;
      line-height: 24px;
      position: relative;
      ${loadAnimation}
    `}
`;
export const TransportInfoAirports = styled(Text).attrs({ variant: 'BodySmall', color: 'textSecondary' })<{
  isWaiting: boolean;
}>`
  ${ellipsis};

  .warning {
    color: ${({ theme }) => theme.kallisto.color.common.semantic.warning[600]};
  }

  ${({ isWaiting }) =>
    isWaiting &&
    css`
      width: 60px;
      border-radius: 4px;
      margin-top: 4px;
      line-height: 16px;
      position: relative;
      ${loadAnimation}
    `}
`;

export const TransportBaggageContainer = styled.div<{ isWaiting: boolean }>`
  margin-left: auto;
  flex-shrink: 0;
  text-align: right;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-end;
  justify-content: space-between;

  div {
    ${({ isWaiting }) =>
      isWaiting &&
      css`
        width: 60px;
        border-radius: 4px;
        margin-bottom: 4px;
        line-height: 16px !important;
        position: relative;
        ${loadAnimation}
      `}
  }
`;
